(function () {
    angular.module('active-if-else.dir', [])
        .directive('activeIfElse', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService', '$timeout', activeIfElse]);

    function activeIfElse($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.specificUrlOptions = [
                    {
                        value: 'any-tracked-page',
                        message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
                    },
                    {
                        value: 'is-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
                    },
                    {
                        value: 'contains-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
                    },
                    {
                        value: 'doesnotcontain-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
                    },
                    {
                        value: 'startswith-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
                    },
                    {
                        value: 'endswith-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
                    },
                    {
                        value: 'wildcardmatch-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
                    }
                ];

                $scope.parseDescription = function(desc) {
                    if (!desc){
                        return 'Description';
                    }
                    return desc;
                };

                //When we save a the form
                $scope.save = function (dummy) {
                    //If form data is missing
                    if ($scope.passesConnectionCheck() === false) {
                        $scope.displayError = true;
                        $rootScope.$emit('errorMsg', $rootScope.translate('canvas.error.601'));

                        if($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                    //Else we proceed to save and create new elements
                    else {
                        Intercom('trackEvent', 'AP Node - Multiple Condition');

                        $rootScope.currentJB = $rootScope.currentJB.map((i) => {
                            if(i.id === $scope.naturalId) {
                                i.data = $scope.connections.data;
                            }

                            return i;
                        });

                        const currentNode = $rootScope.currentJB.filter((i) => {
                            if(i.id === $scope.naturalId) {
                                return i;
                            }
                        });

                        const payload = {
                            JourneyName: $rootScope.currentJBTitle,
                            JourneyVersion: 1,
                            JourneyConfiguration: JSON.stringify($rootScope.currentJB),
                            JourneyTitle : $rootScope.currentJBTitle,
                            JourneyId: $rootScope.currentAPId,
                            NodeUpdated : JSON.stringify(currentNode[0])
                        };

                        canvasService.updateActivatedNodes(payload).then(() => {});

                        //Displays th form data
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIfElseModal');

                        //Displays action menu
                        $scope.displaySubMenuIf = false;
                        $scope.displayInnerSubMenuIf = [];
                        //Hides Error
                        $scope.displayError = false;

                        $scope.displayConditionMenu = [];
                        $scope.displayConditionConnectors = true;

                        if ($scope.isElegibleForUpdate) {
                            $scope.wasSave = true;
                            $timeout(() => {
                                $scope.wasSave = false;
                            }, 1500);
                        }

                        //Set Back to autoSave
                        $scope.isElegibleForUpdate = true;
                    }
                };

                $scope.config = function (evt) {
                    //Show form menu
                    if($scope.displayList === false){
                        $scope.displayList = true;
                        $scope.displayConditionMenu = [];
                        $rootScope.$emit('displayConditionIfElseModal', $scope.connections);
                    }else{
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionIfElseModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                    $scope.displayInnerSubMenuIf = [];
                };

                $scope.passesConnectionCheck = function () {
                    var conditionsGroup = $scope.connections.data.conditionGroups,
                        res = true;

                    if (conditionsGroup === undefined) {
                        res = false;
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                    } else {
                        for (var grp = 0; grp<conditionsGroup.length; grp++) {
                            if (conditionsGroup[grp] === undefined) {
                                res = false;
                            }

                            if (conditionsGroup[grp].length === 0) {
                                res = false;
                            }

                            for (var con = 0; con<conditionsGroup[grp].length; con++) {
                                if(conditionsGroup[grp][con].type === 'list') {
                                    if(conditionsGroup[grp][con].selectedOpt.length === 0) {
                                        res = false;
                                        $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                    }
                                }

                                if (conditionsGroup[grp][con].type === 'url' && (conditionsGroup[grp][con].selectedOpt[0] !== 'any-tracked-page') && !conditionsGroup[grp][con].selectedOpt[1]) {
                                    res = false;
                                    $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                }

                                if ((conditionsGroup[grp][con].selectedOpt[0] === '' || conditionsGroup[grp][con].selectedOpt[0] === undefined) && conditionsGroup[grp][con].type !== 'visited') {
                                    res = false;
                                    $scope.connections.data.conditionGroups[grp][con].hasError = true;
                                }
                            }

                        }
                    }

                    if(!res) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }

                        $rootScope.$emit('inputErrorsConditionIfElse', $scope.connections.data.conditionGroups);
                    }

                    return res;
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function() {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function() {
                    if($scope.displayConditionMenu){
                        var rectangleMenu = $scope.displayConditionMenu.length > 0;
                    }

                    if($scope.displayList || $scope.displaySubMenu || rectangleMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        }else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.displayConditionMenu = [];
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function() {
                    $scope.displayList = false;
                };

            }],
            link: function (scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenuIf = false;
                scope.selectedAction = {};
                scope.ConnectionsFromLoader = false;
                scope.displayPlus = [];
                scope.rectangleCons = [];
                scope.isElegibleForUpdate = true;
                scope.hideWhenLimit = true;
                scope.modalWindow =  [];
                scope.hideForLimitCon = [];
                scope.displayInnerSubMenuIf = [];
                scope.checkList = [];
                scope.listTitle = [];
                scope.append = [];
                scope.urlError = [];
                scope.emailList = helpers.jbContainsSendEmail();
                scope.hasArrow = {};
                scope.showConnectionArrow = {};

                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    scope.connections = $rootScope.aElement;

                    if(!scope.contactListData) {
                        scope.contactListData = $rootScope.contactListData;
                    }

                    if(!scope.segmentData) {
                        scope.segmentData = $rootScope.segmentData;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-if-else');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.naturalId = helpers.getNaturalId(scope.id);
                    scope.color = $rootScope.aElement.color;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.numbers = '0';
                    scope.listTitle = [];
                    scope.nodeTitle = scope.data.actionsList[scope.data.conditionGroups[0][0].selectedAction];

                    if(scope.data.conditionGroups) {
                        for(var i = 0; i<scope.data.conditionGroups.length; i++) {
                            scope.listTitle[i] = [];

                            for(var j=0; j<scope.data.conditionGroups[i].length; j++){

                                var type = scope.data.conditionGroups[i][j].type,
                                    key = scope.data.conditionGroups[i][j].selectedOpt[0];

                                scope.data.conditionGroups[i][j].selectedValue = scope.data.actionsList[scope.data.conditionGroups[i][j].selectedAction];

                                if(type === 'list') {
                                    var val = helpers.getContactListItem(key, scope.contactListData, scope.segmentData);
                                    scope.listTitle[i][j] = val.substring(0,26) + '...';

                                }else if(type === 'email' || type === 'link') {
                                    var emailNodeId = helpers.getLoaderConnectionById(key);
                                    if(emailNodeId.emailData) {
                                        scope.data.conditionGroups[i][j].emailNodeName = emailNodeId.emailData.EmailName;

                                        $rootScope.$on('newActiveEmail' + key, function(evt, summary) {
                                            if(summary && summary.emailName) {
                                                for(let i = 0; i<scope.data.conditionGroups.length; i++) {
                                                    for(let j=0; j<scope.data.conditionGroups[i].length; j++){
                                                        let type = scope.data.conditionGroups[i][j].type,
                                                            key = scope.data.conditionGroups[i][j].selectedOpt[0];

                                                        if(type === 'email' || type === 'link' && key === summary.elementId) {
                                                            scope.data.conditionGroups[i][j].emailNodeName = summary.emailName;
                                                        }
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function(evt, data) {
                        if(data) {
                            scope.numbers = data;
                        }
                    });

                    $rootScope.$on('saveConditionIfElse' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });
                }
            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/conditions/active-if-else.js